import React, { useId } from 'react';

export default function SmartiLabIcon({ className = '', compact = false }) {
  const classes = ['sl-icon-svg', compact ? 'compact' : '', className].filter(Boolean).join(' ');
  const gradientId = useId().replace(/:/g, '');

  return (
    <svg viewBox="0 0 160 160" aria-hidden="true" className={classes}>
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#63f0ff" />
          <stop offset="55%" stopColor="#58a6ff" />
          <stop offset="100%" stopColor="#9388ff" />
        </linearGradient>
      </defs>
      <g className="sl-icon-orbit">
        <polygon
          points="80,16 126,42 126,94 80,120 34,94 34,42"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="3.5"
          strokeLinejoin="round"
        />
        <line x1="80" y1="16" x2="80" y2="56" stroke={`url(#${gradientId})`} strokeWidth="2.8" />
        <line x1="34" y1="42" x2="66" y2="60" stroke={`url(#${gradientId})`} strokeWidth="2.4" />
        <line x1="126" y1="42" x2="94" y2="60" stroke={`url(#${gradientId})`} strokeWidth="2.4" />
        <line x1="34" y1="94" x2="66" y2="76" stroke={`url(#${gradientId})`} strokeWidth="2.4" />
        <line x1="126" y1="94" x2="94" y2="76" stroke={`url(#${gradientId})`} strokeWidth="2.4" />
        <line x1="80" y1="120" x2="80" y2="80" stroke={`url(#${gradientId})`} strokeWidth="2.8" />
        <circle cx="80" cy="16" r="6" fill="#08101c" stroke={`url(#${gradientId})`} strokeWidth="3" />
        <circle cx="126" cy="42" r="6" fill="#08101c" stroke={`url(#${gradientId})`} strokeWidth="3" />
        <circle cx="126" cy="94" r="6" fill="#08101c" stroke={`url(#${gradientId})`} strokeWidth="3" />
        <circle cx="80" cy="120" r="6" fill="#08101c" stroke={`url(#${gradientId})`} strokeWidth="3" />
        <circle cx="34" cy="94" r="6" fill="#08101c" stroke={`url(#${gradientId})`} strokeWidth="3" />
        <circle cx="34" cy="42" r="6" fill="#08101c" stroke={`url(#${gradientId})`} strokeWidth="3" />
      </g>
      <g className="sl-icon-core">
        <circle cx="80" cy="68" r="18" fill="rgba(10, 19, 36, 0.84)" stroke={`url(#${gradientId})`} strokeWidth="4" />
        <circle cx="80" cy="68" r="5" fill="#63f0ff" />
      </g>
    </svg>
  );
}
